/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ signal: NonNullable<unknown> }} Automation_Failure_Alert_SubjectInputs */

const en_automation_failure_alert_subject = /** @type {(inputs: Automation_Failure_Alert_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recobra automation failed: ${i?.signal}`)
};

const pt_br2_automation_failure_alert_subject = /** @type {(inputs: Automation_Failure_Alert_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na automação da Recobra: ${i?.signal}`)
};

/**
* | output |
* | --- |
* | "Recobra automation failed: {signal}" |
*
* @param {Automation_Failure_Alert_SubjectInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_failure_alert_subject = /** @type {((inputs: Automation_Failure_Alert_SubjectInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Failure_Alert_SubjectInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_failure_alert_subject(inputs)
	return pt_br2_automation_failure_alert_subject(inputs)
});